import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { CatalogDialogComponent } from '@core/modal/catalog-dialog/catalog-dialog/catalog-dialog.component';
import { Observable } from 'rxjs';

export interface ConfirmModalConfig extends ConfirmModalContent {
  onConfirm?: () => void;
}

export interface ConfirmModalContent {
  header: string;
  body: string;
  cancelButtonText?: string;
  OKButtonText?: string;
  options?: MatDialogConfig;
}

export interface AlertModalConfig extends AlertModalContent {
  onConfirm?: () => void;
}

export interface AlertModalContent {
  header: string;
  body: string;
  OKButtonText?: string;
}
@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private readonly dialog = inject(MatDialog);

  private dialogRef: MatDialogRef<any>;
  DEFAULT_HEIGHT = '210px';
  DEFAULT_WIDTH = '560px';

  public close(): void {
    this.dialog.closeAll();
  }

  public confirmed$(): Observable<any> {
    return this.dialogRef?.afterClosed();
  }

  public openCatalogDialog(options: ConfirmModalContent): this {
    const dialogConfig: MatDialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;

    dialogConfig.minHeight = '472px';
    dialogConfig.width = '748px';
    dialogConfig.data = {
      OKButtonText: options.OKButtonText,
      body: options.body,
      cancelButtonVisible: false,
      header: options.header,
      options: options.options,
    } as ConfirmModalContent;

    this.dialogRef = this.dialog.open(CatalogDialogComponent, dialogConfig);

    return this;
  }
}
